(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// /*
//  * Enable the code from comments to use JS on the theme
//  */
// import $ from "jquery";
// window.$ = window.jQuery = $;

// import "slick-carousel";
// import "fslightbox";

// /*
//  * Put your code inside the jQuery's ready function
//  */
// // eslint-disable-next-line
// jQuery(document).ready(function ($) {
// 	// CEW Slider Posts
// 	$(".sliderPosts").slick({
// 		// accessibility: false,
// 		// dots: true,
// 		arrows: true,
// 		infinite: true,
// 		speed: 300,
// 		slidesToShow: 3,
// 		prevArrow: $(".sliderPosts-arrow-left"),
// 		nextArrow: $(".sliderPosts-arrow-right"),
// 		responsive: [
// 			{
// 				breakpoint: 1025,
// 				settings: {
// 					centerMode: true,
// 					slidesToShow: 2,
// 				},
// 			},
// 			{
// 				breakpoint: 768,
// 				settings: {
// 					arrows: false,
// 					centerMode: true,
// 					centerPadding: "0px",
// 					slidesToShow: 1,
// 				},
// 			},
// 		],
// 	});

// 	// FS Lightbox trigger
// 	$(".fslightbox-trigger img").wrap(function () {
// 		return `<a data-fslightbox="gallery" href="${this.src}"></a>`;
// 	});
// 	// eslint-disable-next-line
// 	refreshFsLightbox();
// });
"use strict";

},{}]},{},[1]);
